module.exports = __webpack_public_path__ + "img/effect-transmission.611868f2.png";